import { createStore, applyMiddleware, combineReducers } from 'redux';
import reduxReset from 'redux-reset';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import multi from 'redux-multi';
import commonReducer from './app/common/common.reducer';
import recebimentoMaterialReducer from './pages/laudo/etapas/material/material.reducer';
import macroscopiaReducer from './pages/laudo/etapas/macroscopia/macroscopia.reducer';
import microscopiaReducer from './pages/laudo/etapas/microscopia/microscopia.reducer';
import histologiaReducer from './pages/laudo/etapas/histo/histo.reducer';
import imunologiaReducer from './pages/laudo/etapas/imuno/imuno.reducer';
import fishReducer from './pages/laudo/etapas/fish/fish.reducer';
import cishReducer from './pages/laudo/etapas/cish/cish.reducer';
import congelacaoReducer from './pages/laudo/etapas/congelacao/congelacao.reducer';
import pcrReducer from './pages/laudo/etapas/pcr/pcr.reducer';
import notasReducer from './pages/laudo/etapas/notas/notas.reducer';
import erratasReducer from './pages/laudo/etapas/erratas/erratas.reducer';
import RC_laminaReducer from './app/common/requisicaoCongelacao/tabs/lamina/lamina.reducer';
import RC_blocoReducer from './app/common/requisicaoCongelacao/tabs/bloco/bloco.reducer';
import editorReducer from './pages/laudo/editor/editor.reducer';
import editorComponentReducer from './componentes/editor/editor.reducer';
import usuarioReducer from './app/common/usuario/usuario.reducer';
import avisosReducer from './app/common/avisos/avisos.reducer';
import certificacaoReducer from './app/common/certificacao/certificacao.reducer';
import conclusaoReducer from './pages/laudo/etapas/conclusao/conclusao.reducer';
import configMaterial from './pages/configuracao/tab/material/recebimento.reducer';
import filtrosReducer from './pages/main/filtros/filtro.reducer';
import tarefasReducer from './pages/tarefas/tarefas.reducer';
import KanbanReducer from './componentes/dragdrog/store/kanban.reducer';
import organizarReducer from './componentes/dragdrog/organizarLote/store/organizar.reducer';
import descarteReducer from './pages/descarte/tabs/descarte/store/descarte.reducer';
import materiaisReducer from './pages/descarte/tabs/materiais/store/materiais.reducer';
import relatoriosReducer from './pages/descarte/tabs/relatorios/store/relatorios.reducer';
import descarteCommonReducer from './pages/descarte/common/store/descarte.reducer';
import arquivamentoRelatoriosReducer from './pages/arquivamento/tabs/Relatorios/store/relatorios.reducer';
import arquivamentoCommonReducer from './pages/arquivamento/common/store/arquivamento.reducer';
import modalLiberacaoParcialReducer from './pages/laudo/modais/liberacao_parcial/store/liberacao.reducer';
import modalLiberacaoTotaoReducer from './pages/laudo/modais/liberacao_total/store/liberacaoTotal.reducer';
import relatorioReducer from './pages/relatorio/relatorio.reducer';
import solicitacoesReducer from './pages/solicitacao/solicitacao.reducer';
import baseConhecimentoReducer from '@containers/BaseConhecimento/store/base.reducer';
import { createLogger } from 'redux-logger';
import { compose } from 'redux';

const reducers = combineReducers({
  avisos: avisosReducer,
  certificacao: certificacaoReducer,
  commonReducer: commonReducer,
  recebimentoMaterial: recebimentoMaterialReducer,
  configMaterial: configMaterial,
  macroscopia: macroscopiaReducer,
  microscopia: microscopiaReducer,
  histologia: histologiaReducer,
  imunologia: imunologiaReducer,
  fish: fishReducer,
  cish: cishReducer,
  pcr: pcrReducer,
  congelacao: congelacaoReducer,
  notas: notasReducer,
  erratas: erratasReducer,
  conclusao: conclusaoReducer,
  editor: editorReducer,
  editorComponent: editorComponentReducer,
  usuario: usuarioReducer,
  laminaCongelacao: RC_laminaReducer,
  blocoCongelacao: RC_blocoReducer,
  filtros: filtrosReducer,
  tarefas: tarefasReducer,
  descarteCommon: descarteCommonReducer,
  descarteMaterial: descarteReducer,
  materiaisDescartados: materiaisReducer,
  descarteRelatorios: relatoriosReducer,
  kanban: KanbanReducer,
  organizarLote: organizarReducer,
  arquivamentoCommon: arquivamentoCommonReducer,
  arquivamentoRelatorios: arquivamentoRelatoriosReducer,
  modalLiberacaoParcial: modalLiberacaoParcialReducer,
  modalLiberacaoTotal: modalLiberacaoTotaoReducer,
  relatorio: relatorioReducer,
  solicitacao: solicitacoesReducer,
  baseConhecimento: baseConhecimentoReducer
});

const APP = 'RESET';

const logger = createLogger({
  collapsed: true,
  duration: true,
  timestamp: true,
  level: 'log',
  logErrors: true
});

let store = compose(
  applyMiddleware(thunk, multi, promise),
  reduxReset(APP)
)(createStore);

if (
  process.env.NODE_ENV === 'development' &&
  window.__REDUX_DEVTOOLS_EXTENSION__
) {
  const devtools =
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true });
  store = compose(
    applyMiddleware(thunk, multi, promise, logger),
    reduxReset(APP),
    devtools
  )(createStore);
} else if (process.env.NODE_ENV === 'development') {
  store = compose(
    applyMiddleware(thunk, multi, promise, logger),
    reduxReset(APP)
  )(createStore);
}

export default store(reducers);



// WEBPACK FOOTER //
// ./src/configureStore.util.js